<template>
  <div class="private-domain-traffic">
    <div class="private-domain-traffic__header">
      <h4 class="fz16 mb10 pr20">{{ setting.title }}</h4>
      <p class="tip">{{ setting.desc }}</p>
    </div>
    <div class="private-domain-traffic__main">
      <van-image
        class="qr-code-box"
        width="160px"
        height="160px"
        :fit="isTrain ? 'contain' : ''"
        :src="setting.qrCodeUrl"
      />
      <div class="guide-tip">{{ setting.leadingWords }}</div>
    </div>
    <div v-if="isTrain">
      <div class="guide-phone" v-if="setting.contactPhone">
        <span class="guide-phone__left">咨询热线</span>
        <span class="guide-phone__center">{{ setting.contactPhone }}</span>
        <a class="guide-phone__right" :href="`tel:${setting.contactPhone}`"
          >拨打</a
        >
      </div>
    </div>
    <div class="guide-phone" v-else-if="hasContactPhone">
      <span class="guide-phone__left">咨询热线</span>
      <span class="guide-phone__center">{{ setting.contactPhone }}</span>
      <a class="guide-phone__right" :href="`tel:${setting.contactPhone}`"
        >拨打</a
      >
    </div>
    <div class="guide-phone" v-else-if="setting.noticeText">
      <span class="guide-phone__center">{{ setting.noticeText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivateTraffic',
  props: {
    setting: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    hasContactPhone({ setting }) {
      return setting && setting.contactType != 1 && setting.contactPhone
    },
    isTrain() {
      // 知识培训私域引流不填写手机号码不显示咨询热线
      const list = [
        'camp',
        'course',
        'picture',
        'radio',
        'video',
        'purchase_camp',
        'purchase_course',
        'purchase_picture',
        'purchase_radio',
        'purchase_video',
      ]
      if (this.setting && list.includes(this.setting.relatedPage)) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.private-domain-traffic {
  padding: 16px 16px 0;
  &__header {
    line-height: 1.2em;
    margin-bottom: 30px;
    .tip {
      color: #60646b;
    }
  }
  &__main {
    display: flex;
    flex-direction: column;
    align-items: center;
    .qr-code-box {
      box-sizing: border-box;
      padding: 6px;
      border-radius: 4px;
      border: 3px solid #ccddff;
      background-color: #fff;
    }
    .guide-tip {
      display: inline-block;
      margin-top: 10px;
      color: #01286f;
      font-size: 14px;
      font-weight: 500;
      line-height: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }
  .guide-phone {
    padding: 16px;
    background: #fff;
    border-radius: 5px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    .common {
      font-size: 14px;
      color: #48618d;
      font-weight: 400;
    }
    &__left {
      padding-right: 16px;
      border-right: 1px solid #a2cfff;
      @extend .common;
      margin-right: 16px;
    }
    &__right {
      @extend .common;
      text-decoration: none;
      &:hover {
        text-decoration: none;
      }
    }
    &__center {
      font-size: 14px;
      color: #001a47;
      font-weight: 400;
      flex: 1;
    }
  }
}
</style>
